import DisplayCard from 'src/components/Card/DisplayCard';
import { Flex } from 'src/components/Flex';

type TotalsProps = {
    outstandingBalance: string;
    balanceBroughtForward: string;
    totalInvoiceAmount: string;
    totalCreditApplied: string;
    totalPaymentsMade: string;
    balanceLabel: string;
};

const StatementTotals = ({
    balanceBroughtForward,
    outstandingBalance,
    totalInvoiceAmount,
    totalCreditApplied,
    totalPaymentsMade,
    balanceLabel,
}: TotalsProps) => {
    return (
        <>
            <Flex flexDirection="row" gap="24px">
                <DisplayCard label={balanceLabel} value={balanceBroughtForward} />
                <DisplayCard label="Outstanding Balance" value={outstandingBalance} />
            </Flex>
            <Flex flexDirection="row" gap="19px">
                <DisplayCard label="Total Invoice Amounts" value={totalInvoiceAmount} />
                <DisplayCard label="Total Credit Applied" value={totalCreditApplied} />
                <DisplayCard label="Total Payments Made" value={totalPaymentsMade} />
            </Flex>
        </>
    );
};

export default StatementTotals;
